import { useLocation } from "react-router-dom";
import { Grid } from "@financeable-com-au/financeable-ui";
import { ApplicationType } from "@/store/slices/types/applicationFormSlice";
import { PrivacyCreditGuide } from "@/components/PrivacyCreditGuide";
import { PrivacyParams } from "@/components/PrivacyCreditGuide/PrivacyCreditGuide";

export default function Privacy() {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const applicationType = params.applicationType as ApplicationType;

  return (
    <Grid
      container
      xs={12}
      style={{
        padding: "30px 30px 0",
        background: "#efefef",
        minHeight: "calc(100vh - 64px)",
      }}
    >
      <Grid container xs={12} justifyContent="center">
        <Grid direction="column" xs={12} sm={12} md={10} lg={6} xl={6}>
          <PrivacyCreditGuide applicationType={applicationType} params={params as unknown as PrivacyParams} />
        </Grid>
      </Grid>
    </Grid>
  );
}
